export default __webpack_public_path__ + "static/media/hd_ic_bot.13c2f314.svg";